import { Component, ElementRef, Input, Renderer2, ViewEncapsulation, inject } from '@angular/core';

import { VerticalMenuComponent } from './vertical-menu/vertical-menu';
import { HorizontalMenuComponent } from './horizontal-menu/horizontal-menu';

@Component({
    selector: 'app-menu',
    templateUrl: './menu.html',
    styleUrl: './menu.scss',
    encapsulation: ViewEncapsulation.None,
    imports: [VerticalMenuComponent, HorizontalMenuComponent]
})
export class MenuComponent {
  private _elementRef = inject(ElementRef);
  private _renderer = inject(Renderer2);

  private _menuType: string;

  /**
   * Constructor
   *
   * @param {ElementRef} _elementRef
   * @param {Renderer2} _renderer
   */
  constructor() {
    // Set the default menu
    this._menuType = 'vertical-menu';
  }

  // Accessors
  // -----------------------------------------------------------------------------------------------------

  //Get the menu type
  get menuType(): string {
    return this._menuType;
  }

  @Input()
  //Set the menu type to the native element
  set menuType(value: string) {
    // Remove the old class name from native element
    this._renderer.removeClass(this._elementRef.nativeElement, this.menuType);

    // Store the menuType value
    this._menuType = value;

    // Add the new class name from native element
    this._renderer.addClass(this._elementRef.nativeElement, value);
  }
}
